export default "__VITE_ASSET__BfJl0Tym__"